export enum LineJoinEnum {
  MITER = 'miter',
  ROUND = 'round',
  BEVEL = 'bevel',
  MITER_CLIP = 'miter-clip',
}
